"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SrvLog = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var SrvLog = /*#__PURE__*/function () {
  function SrvLog(service, funct) {
    (0, _classCallCheck2["default"])(this, SrvLog);
    this.service = service;
    this.funct = funct;
  }
  (0, _createClass2["default"])(SrvLog, [{
    key: "setResponse",
    value: function setResponse(body, error, date, message, ms) {
      this.body = body;
      this.error = error;
      this.date = date;
      this.message = message;
      this.ms = ms;
    }
  }]);
  return SrvLog;
}();
exports.SrvLog = SrvLog;
//# sourceMappingURL=SrvLog.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/SrvLog.js
// module id = 481
// module chunks = 142